<template>
  <img
    class="rounded-full ring-black object-cover shadow-md"
    :src="pathToImage"
    :style="computedStyles"
    alt="Vue logos"
  />
</template>

<script>
export default {
  name: "Avatar",
  components: {},
  props: {
    src: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 30
    }
  },
  computed: {
    computedStyles() {
      return {
        height: `${this.size}px`,
        "min-width": `${this.size}px`
      };
    },
    pathToImage() {
      if (!this.src) {
        return require("@/assets/avatars/img_fallback.png");
      } else if (
        this.src.startsWith("https://") ||
        this.src.startsWith("http://")
      ) {
        return "";
      }

      return require(`@/assets/avatars/${this.src}`);
    }
  },
  data() {
    return {
      selectedDog: ""
    };
  },
  created() {}
};
</script>

<style></style>
